import React from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { UserButton } from '@clerk/clerk-react';
import { useTheme } from '@incubs/ui';
import { IncubsLogo } from '../IncubsLogo';
import { useSchoolTheme } from '../../hooks/useSchoolTheme';

const Nav = styled.nav<{ $light: boolean }>`
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.75rem;
  background: ${({ $light }) =>
    $light ? 'rgba(255, 255, 255, 0.92)' : 'rgba(4, 4, 14, 0.76)'};
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border-bottom: 1px solid
    ${({ $light }) =>
      $light ? 'rgba(109, 40, 217, 0.08)' : 'rgba(255, 255, 255, 0.05)'};
  box-shadow: ${({ $light }) =>
    $light
      ? '0 1px 0 rgba(109,40,217,0.06), 0 4px 24px rgba(109,40,217,0.04)'
      : '0 1px 0 rgba(255,255,255,0.03)'};
`;


const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
`;

const ThemeToggle = styled(motion.button)<{ $light: boolean }>`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  background: ${({ $light }) =>
    $light ? 'rgba(109, 40, 217, 0.06)' : 'rgba(255, 255, 255, 0.06)'};
  color: ${({ $light }) => ($light ? '#6d28d9' : 'rgba(255,255,255,0.65)')};
  border: 1px solid
    ${({ $light }) =>
      $light ? 'rgba(109, 40, 217, 0.12)' : 'rgba(255, 255, 255, 0.08)'};
  cursor: pointer;
  outline: none;
  transition: background 200ms ease, border-color 200ms ease, color 200ms ease;

  &:hover {
    background: ${({ $light }) =>
      $light ? 'rgba(109, 40, 217, 0.12)' : 'rgba(255, 255, 255, 0.10)'};
  }
`;

export default function Navbar() {
  const { mode, toggleMode } = useTheme();
  const { theme } = useSchoolTheme();
  const $light = mode === 'light';

  return (
    <Nav $light={$light}>
      <IncubsLogo to="/dashboard" primary={theme.primary} size="lg" />
      <Actions>
        <ThemeToggle
          $light={$light}
          onClick={toggleMode}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.9, rotate: 20 }}
          title={$light ? 'Switch to dark mode' : 'Switch to light mode'}
        >
          {$light ? '🌙' : '☀️'}
        </ThemeToggle>
        <UserButton afterSignOutUrl="/" />
      </Actions>
    </Nav>
  );
}
